import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgVitaminCGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.454 10.026 17.096 10l-.203.295-8.689 12.646-.204.297.155.325 6.592 13.85.155.326.36.028 15.281 1.204.36.029.204-.298 8.69-12.645.203-.296-.153-.325-6.592-13.95-.156-.33-.364-.026-15.281-1.104ZM9.439 23.35l8.282-12.053 14.56 1.052 6.282 13.295-8.282 12.052-14.56-1.148-6.282-13.198Zm13.32-8.545c-1.84-.137-3.242 1.139-3.38 3.015-.14 1.885 1.06 3.364 2.909 3.502 1.606.12 2.62-.644 3.061-1.983l-1.301-.097c-.26.594-.796.997-1.675.931-1.122-.084-1.801-1.037-1.71-2.257.088-1.212.9-2.045 2.012-1.962.844.062 1.274.474 1.452 1.11l1.356.1c-.239-1.29-1.125-2.24-2.723-2.36Zm5.01 8.57-.554-.288-.286.556-2.52 4.903-.286.556.554.288 4.881 2.533.555.288.285-.556 2.52-4.904.287-.556-.555-.288-4.88-2.532Zm-1.965 5.191 1.949-3.792 3.77 1.957-1.948 3.792-3.771-1.957Zm-6.166-1.827-.27-.564-.562.27-2.703 1.3-.563.271.269.564 1.293 2.716.268.564.563-.27 2.703-1.3.563-.271-.268-.564-1.293-2.716Zm-2.434 1.864 1.576-.758.755 1.587-1.576.758-.755-1.587Z",
    fill: "currentColor"
  }));
}

export { SvgVitaminCGlyph as default };
